import fire from "../base";
import store from 'store';

export function setAuthListener(dispatch, callback) {
  const toUnsubscribe = [];
  toUnsubscribe.push(fire.auth().onAuthStateChanged(user => {
    if (user) {

      toUnsubscribe.push(fire.firestore().collection('users').doc(user.uid).collection('stati').orderBy("unixTimestamp", "desc").limit(7).onSnapshot(snapshot => {
      // toUnsubscribe.push(fire.firestore().collection('users').doc(user.uid).collection('stati').where("unixTimestamp", ">", d.getTime()).onSnapshot(snapshot => {
        dispatch({ type: "STATI_UPDATED", payload: { stati: snapshot.docs.map(doc => ({ ...doc.data(), uid: doc.id })).reverse() } });
      }, console.log));

      toUnsubscribe.push(fire.firestore().collection('users').doc(user.uid).onSnapshot(snapshot => {
        const preferences = snapshot.get('preferences');
        dispatch({ type: "EDIT_PREFERENCES", payload: { preferences } });
        store.set("preferences", preferences);
      }, console.log));

      dispatch({ type: "AUTH_STATE_CHANGED", payload: { user, isAuthenticated: true } });
      store.set("isAuthenticated", true);
    } else {
      dispatch({ type: "AUTH_STATE_CHANGED", payload: { user: null, isAuthenticated: false } });
      store.set("isAuthenticated", false);
    }
    callback(user);
  }));
  return toUnsubscribe;
}